import { DateTime } from "luxon";
import { RespondentModel } from "../../../models/RespondentModel";
import { NavigationState } from "../../../models/states/NavigationState";
import { PageModel } from "../../../models/PageModel";
import {
    RESPONDENT_CHANGED,
    RESPONDENT_SET_APPOINTMENT,
    RESPONDENT_SET_EMAIL,
    RESPONDENT_SET_PHONE,
    RESPONDENT_SET_TIMEZONE,
    CHANGE_LANGUAGE,
    NAVIGATION_PAGE_READY,
    NAVIGATION_NEXT_PAGE,
    SET_COORDINATES,
} from "../../actions";
import { ActionTypes } from "../../actions/types";

export const respondentSliceReducer = (
    state: RespondentModel,
    action: ActionTypes,
    navigation: NavigationState,
    previousPage: PageModel,
): RespondentModel => {
    switch (action.type) {
        case RESPONDENT_CHANGED:
            return action.respondent;
        case RESPONDENT_SET_APPOINTMENT:
            return { ...state, appointmentDate: action.appointment };
        case RESPONDENT_SET_EMAIL:
            return { ...state, email: action.email };
        case RESPONDENT_SET_PHONE:
            return { ...state, phone: action.phone };
        case RESPONDENT_SET_TIMEZONE:
            return { ...state, timeZone: action.timeZone };
        case CHANGE_LANGUAGE:
            return { ...state, language: action.code };
        case NAVIGATION_PAGE_READY:
            if (!navigation.history && !state.sessionStartTime)
                return {
                    ...state,
                    firstAnsweredQuestion: navigation.currentPage.questions[0].name,
                    sessionStartTime: DateTime.utc(),
                };
            return state;
        case NAVIGATION_NEXT_PAGE:
            if (previousPage && !previousPage.isShortcut)
                return { ...state, lastAnsweredQuestion: previousPage.questions.slice(-1)[0].name };
            return state;
        case SET_COORDINATES:
            return {
                ...state,
                latitude: action.latitude,
                longitude: action.longitude,
            };
        default:
            return state;
    }
};
